module.exports = __webpack_public_path__ + "img/tab21.ede869ae.png";